module.exports = __webpack_public_path__ + "img/card_v1.69b3869.png";